import React, { FC } from 'react';
import { SelectedFilterSummaryStyled } from './styled';

interface SelectedFilterSummaryProps {
        varTitle?: string
        selectedValuesLabel?: string
}

const SelectedFilterSummary: FC<SelectedFilterSummaryProps> = ({ varTitle, selectedValuesLabel }) => {
    const label = varTitle ? `${varTitle} ${selectedValuesLabel ? ` :  ${selectedValuesLabel}` : ''}` : `${selectedValuesLabel ? `${selectedValuesLabel}` : ''}`;

    return (
        // The title keeps the whole label reachable once it is cut short.
        <SelectedFilterSummaryStyled title={label}>
            {label}
        </SelectedFilterSummaryStyled>
    );
};

export default SelectedFilterSummary;
